import { VOUCH_COPY } from '../vouch.copy';
import './VouchLocked.scss';

interface Props {
  committed: number;
}

/**
 * Shown in the give-section when the signed-in user has no available credits,
 * instead of a search + a silently-disabled confirm (TRIL-397). Explains why
 * vouching is locked: either nothing earned yet, or everything is committed to
 * active vouches.
 */
export function VouchLocked({ committed }: Props) {
  return (
    <div className="vouch-locked">
      <h2 className="vouch-locked__heading">{VOUCH_COPY.lockedHeading}</h2>
      <p className="vouch-locked__body">
        {committed > 0
          ? VOUCH_COPY.lockedCommitted(committed)
          : VOUCH_COPY.lockedNoCredits}
      </p>
    </div>
  );
}
